import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "underscore";
import {
  Alert,
  AlertInfo,
  CustomInput,
  DefaultLoader,
  Dropdown,
  ProfileDropdown,
  StepLabel,
} from "../../components";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { validateEmail } from "../../utils/functions/validateEmail";
import { withErrorBoundary } from "../../utils/functions/withErrorBoundary";
import { resetData } from "../redux/action";
import {
  getAddress,
  getRaceV2,
  getStateV2,
  setGetAddressLoading,
  setOnboardStepOne,
} from "./redux/action";
import { checkEmptyArray, checkEmptyObject, findAddress } from "./utils.js";

import "./style.scss";
import { POS_00001 } from "../../utils/errorCodes.js";
function ProfileFormStepOne(props) {
  const {
    profile = {},
    getStateV2,
    stateListV2 = [],
    getRaceV2,
    getAddress,
    getAddressLoading,
    address,
    raceLIstV2 = [],
    getRaceLoading,
    getStateLoading,
    setOnboardStepOne,
    history,
    resetData,
    location,
    setGetAddressLoading,
  } = props;

  const [profileInfo, setProfileInfo] = useState({});

  const {
    fullName = "",
    identities = [],
    mobileNo = "",
    contacts = [],
    race = "",
    email = "",
  } = profileInfo;

  const [requireInfo, setRequireInfo] = useState({});
  const [isBlank, setIsBlank] = useState(false);

  const [value, setValue] = useState({
    idNo: "",
    race: { name: "", code: "" },
    email: "",
    address: {
      city: "",
      country: "",
      line1: "",
      line2: "",
      line3: "",
      postCode: "",
      state: {
        name: "",
        code: "",
      },
    },
  });

  const [fieldError, setFieldError] = useState({
    email:
      location.state &&
      location.state.hasOwnProperty("invalidEmail") &&
      location.state.invalidEmail
        ? true
        : false,
    state: false,
    race: false,
    postCode: false,
  });

  const [invalidEmailPrompt, setInvalidEmailPrompt] = useState(
    fieldError.email
  );

  const emailRef = useRef(null);
  const isDirty = useRef(false);

  const initialGetAddressLoading = !isDirty.current && getAddressLoading;
  const subsequentGetAddressLoading = isDirty.current && getAddressLoading;

  const [openDropdown, setOpenDropdown] = useState({
    state: false,
    race: false,
  });

  useEffect(() => {
    getStateV2();
    getRaceV2();
    setGetAddressLoading(false);
  }, []);

  useEffect(() => {
    if (value.address?.postCode?.length === 5) {
      setGetAddressLoading(true);
      setFieldError(prev => ({ ...prev, postCode: false }));
      getAddress(value.address.postCode, err => {
        if (err?.errorCode === POS_00001) {
          setFieldError(prev => ({ ...prev, postCode: true }));
        } else {
          setFieldError(prev => ({ ...prev, postCode: false }));
        }
      });
    } else {
      setFieldError(prev => ({ ...prev, postCode: true }));
    }
  }, [value.address.postCode]);

  useEffect(() => {
    if (Object.values(address).length > 0) {
      const state = stateListV2.find(item => item.code === address.state);

      setValue(prev => ({
        ...prev,
        address: {
          ...prev.address,
          postCode: address.postalCode,
          city: address.city,
          state: {
            name: state?.name,
            code: state?.code,
          },
        },
      }));
    }
  }, [address, stateListV2]);

  const handleSelectRace = id => {
    let tempRace = { name: "", code: "" };
    const raceItem = raceLIstV2.find(item => item.code === id);
    if (raceItem) {
      tempRace = { name: raceItem.name, code: raceItem.code };
    } else {
      setOpenDropdown({ ...openDropdown, race: false });

      return;
    }

    setValue({ ...value, race: tempRace });
    setOpenDropdown({ ...openDropdown, race: false });
    setFieldError({ ...fieldError, race: false });
  };

  const handleChangeEmail = val => {
    setValue({ ...value, email: val });
  };

  const findIdNo = () => {
    let tempidNo = "";
    let tempValue = [];
    if (Array.isArray(identities)) {
      tempValue = identities.filter(item => item.idTypeCd !== "TAX");
    }
    if (tempValue.length > 0 && "idNo" in tempValue[0]) {
      tempidNo = tempValue[0].idNo;
    }
    return tempidNo;
  };

  const findRace = () => {
    let tempRace = { name: "", code: "" };
    let newItem = [];
    if (Array.isArray(raceLIstV2)) {
      newItem = raceLIstV2.filter(item => item.code === race);
    } else {
      return tempRace;
    }

    if (newItem.length > 0) {
      if ("name" in newItem[0] && "code" in newItem[0]) {
        tempRace = { name: newItem[0].name, code: newItem[0].code };
      }
    }
    return tempRace;
  };

  const findEmail = () => {
    let tempEmail = "";
    if (email === null || !email) {
      return tempEmail;
    }
    tempEmail = email;
    return tempEmail;
  };

  useEffect(() => {
    if (
      typeof profile === "object" &&
      !Array.isArray(profile) &&
      profile !== null
    ) {
      setProfileInfo(profile);
    }
  }, [profile]);

  useEffect(() => {
    let checkProfileForm = checkEmptyObject(profileInfo);
    let checkStatelist = checkEmptyArray(stateListV2);
    let checkRaceList = checkEmptyArray(raceLIstV2);
    if (!checkProfileForm || !checkRaceList || !checkStatelist) {
      return;
    }

    let tempIdNo = findIdNo();
    let tempRace = findRace();
    let tempEmail = findEmail();
    const tempAddress = findAddress(contacts);

    setValue(prev => ({
      ...prev,
      idNo: tempIdNo,
      race: tempRace,
      email: tempEmail,
      address: {
        ...prev.address,
        postCode: tempAddress.postCode,
        country: tempAddress.country,
        line1: tempAddress.line1,
        line2: tempAddress.line2,
        line3: tempAddress.line3,
      },
      mobileNo,
    }));
  }, [profileInfo, stateListV2, raceLIstV2]);

  const handleValidateEmail = value => {
    const validation = validateEmail(value);

    if (validation) {
      setFieldError({ ...fieldError, email: false });
    } else {
      setFieldError({ ...fieldError, email: true });
    }
  };

  const validationValue = () => {
    let tempError = {
      postCode: false,
      race: false,
      email: false,
    };
    let requireField = {
      postCode: value.address.postCode,
      race: value.race.code,
      email: value.email,
    };

    for (const key in requireField) {
      if (requireField[key].length === 0) {
        tempError[key] = true;
      }
    }

    setFieldError(prevState => ({
      ...prevState,
      postCode: tempError.postCode,
      race: tempError.race,
      email: tempError.email,
    }));
    let requireInfoTemp = {};
    if (tempError.postCode) {
      requireInfoTemp.postCode = "Postal Code";
    }
    if (tempError.race) {
      requireInfoTemp.race = "Race";
    }

    if (tempError.email) {
      requireInfoTemp.email = "Email";
    }
    setRequireInfo(requireInfoTemp);
    for (const key in tempError) {
      if (tempError[key] === true) {
        return false;
      }
    }

    return true;
  };

  const submitStepOne = () => {
    if (
      (value.address.postCode.length > 0 && fieldError.postCode) ||
      getAddressLoading
    ) {
      return;
    }

    let validation = validationValue();

    if (!validation) {
      setIsBlank(true);

      return;
    }

    const validationEmail = validateEmail(value.email);
    if (!validationEmail) {
      setFieldError({ ...fieldError, email: true });
      return;
    }
    setOnboardStepOne(value);
    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      `Click Onboarding Submit Step 1`
    );

    if (location.state) {
      history.push("/onBoarding/form-step-two", location.state);
    } else {
      history.push("/onBoarding/form-step-two");
    }

    return;
  };

  if (getRaceLoading || getStateLoading || initialGetAddressLoading)
    return <DefaultLoader />;

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Alert
        title="Please fill in required fields"
        isObject={requireInfo}
        isOpen={isBlank}
        isCancel={false}
        handleAction={() => setIsBlank(false)}
      />
      <StepLabel
        title="Profile info"
        containerStyles={{ padding: "16px 16px 22px" }}
        onClick={() => {
          resetData();
          localStorage.removeItem("mpUserInfo");
          history.push("/");
        }}
      />
      <AlertInfo
        handleAction={() => {
          setInvalidEmailPrompt(false);
          emailRef?.current?.scrollIntoView({ behavior: "smooth" });
        }}
        description="Please enter your email address to continue."
        isOpen={invalidEmailPrompt}
      />
      <Box sx={{ margin: "0px 16px 4px 16px" }}>
        <Typography
          color="secondary"
          sx={{ fontSize: "14px", fontWeight: "700" }}
        >
          Step 1 of 2
        </Typography>
      </Box>
      <Box sx={{ margin: "0 16px 16px" }}>
        <Typography color="secondary" sx={{ fontWeight: "700" }}>
          Identification & contact information
        </Typography>
      </Box>
      <Box style={{ margin: "0 16px" }}>
        <CustomInput
          label="Full name"
          name="fullName"
          value={fullName}
          isEdit={false}
          isRequired={true}
        />
        <CustomInput
          label="ID Number"
          name="idNumber"
          value={value.idNo}
          isEdit={false}
          isRequired={true}
        />
        <CustomInput
          label="Contact number"
          name="contactNumber"
          value={mobileNo.length > 8 ? mobileNo.slice(2) : mobileNo}
          countryCode={
            mobileNo.length > 8 ? mobileNo.substring(0, 2) : undefined
          }
          isEdit={false}
          isRequired={true}
          isPhone={true}
        />

        <CustomInput
          label="Post Code"
          name="postCode"
          value={value.address?.postCode}
          isRequired={true}
          isEdit
          error={fieldError.postCode}
          maxLength={5}
          onChange={e => {
            if (!isDirty.current) {
              isDirty.current = true;
            }

            const code = e.target.value;
            const reg = new RegExp(/^(\d+)?$/);
            if (reg.test(code)) {
              setValue(prev => ({
                ...prev,
                address: { ...prev.address, postCode: code },
              }));
            }
          }}
          helperText={
            value.address.postCode === ""
              ? "This field is required"
              : "Please enter a valid postal code"
          }
        />
        <Typography
          color="textPrimary"
          sx={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: 1.57,
            marginBottom: "8px",
          }}
        >
          City *
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={
            subsequentGetAddressLoading || fieldError.postCode
              ? ""
              : value.address.city?.replace(
                  /\b[A-Z]+\b/g,
                  match => match.charAt(0) + match.slice(1).toLowerCase()
                )
          }
          FormHelperTextProps={{
            className: "c-input__text",
          }}
          inputProps={{
            className: "c-input c-input--outline",
            style: {
              padding: "12px 16px",
              width: `${subsequentGetAddressLoading ? "40%" : "100%"}`,
            },
          }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          InputProps={{
            className: "c-input__wrapper--disabled",
            readOnly: true,
            disabled: true,

            startAdornment: subsequentGetAddressLoading ? (
              <>
                <div className="loader" />
                <span style={{ display: "inline-block", marginLeft: "5px" }}>
                  Retrieving city
                </span>
              </>
            ) : null,
          }}
        />
        <Typography
          color="textPrimary"
          sx={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: 1.57,
            marginBottom: "8px",
          }}
        >
          State *
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={
            subsequentGetAddressLoading || fieldError.postCode
              ? ""
              : value.address.state?.name
          }
          FormHelperTextProps={{
            className: "c-input__text",
          }}
          inputProps={{
            className: "c-input c-input--outline",
            style: {
              padding: "12px 16px",
              width: `${subsequentGetAddressLoading ? "40%" : "100%"}`,
            },
          }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          InputProps={{
            className: "c-input__wrapper--disabled",
            readOnly: true,
            disabled: true,

            startAdornment: subsequentGetAddressLoading ? (
              <>
                <div className="loader" />
                <span style={{ display: "inline-block", marginLeft: "5px" }}>
                  Retrieving state
                </span>
              </>
            ) : null,
          }}
        />
        <CustomInput
          label="Ethnicity / Race"
          name="race"
          value={value.race.name}
          isEdit={true}
          isRequired={true}
          isDropdown={true}
          onClick={() => setOpenDropdown({ ...openDropdown, race: true })}
          error={fieldError.race}
        />
        <Dropdown
          bottomHeight={({ maxHeight }) => maxHeight * 0.4}
          isOpen={openDropdown.race}
          handleDismiss={() =>
            setOpenDropdown({ ...openDropdown, race: false })
          }
        >
          <ProfileDropdown
            title="Race"
            itemList={raceLIstV2}
            selectedItem={value.race.code}
            handleClick={handleSelectRace}
          />
        </Dropdown>
        <CustomInput
          label="Email"
          name="email"
          placeholder="user@example.com"
          type="email"
          value={value.email}
          onChange={e => handleChangeEmail(e.target.value)}
          handleBlur={() => handleValidateEmail(value.email)}
          error={fieldError.email}
          isEdit={true}
          isRequired={true}
          maxLength={60}
          inputRef={emailRef}
          helperText={
            value.email.length > 0
              ? "Invalid email format"
              : "This field is required"
          }
        />
      </Box>
      <div className="button-container-onboard">
        <button onClick={submitStepOne} className="button-onboard-step1">
          Next
        </button>
      </div>
    </div>
  );
}
const mapStateToProps = state => {
  return { ...state.onBoardingReducer, profile: state.goal.profile };
};
const mapDispatchToProps = dispatch => ({
  getStateV2: () => dispatch(getStateV2()),
  getRaceV2: () => dispatch(getRaceV2()),
  resetData: () => dispatch(resetData()),
  setOnboardStepOne: payload => dispatch(setOnboardStepOne(payload)),
  getAddress: (postCode, cb) => dispatch(getAddress(postCode, cb)),
  setGetAddressLoading: () => dispatch(setGetAddressLoading()),
});
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
export default compose(
  withErrorBoundary,
  withRouter,
  withConnect
)(ProfileFormStepOne);
